module.exports = __webpack_public_path__ + "static/img/sch-105.571b35fd.png";